import axios from 'axios';

const API_URL = '/api/admin';
axios.defaults.headers.post['Authorization'] = 'Bearer ' + localStorage.getItem('token');
axios.defaults.headers.get['Authorization'] = 'Bearer ' + localStorage.getItem('token');
axios.defaults.headers.put['Authorization'] = 'Bearer ' + localStorage.getItem('token');
axios.defaults.headers.delete['Authorization'] = 'Bearer ' + localStorage.getItem('token');

export default {
    // ============ جشنواره‌ها ============

    // لیست جشنواره‌ها
    getPromotions(params = {}) {
        return axios.get(`${API_URL}/promotions`, { params });
    },

    // ایجاد جشنواره جدید
    createPromotion(data) {
        return axios.post(`${API_URL}/promotions`, data);
    },

    // ویرایش جشنواره
    updatePromotion(id, data) {
        return axios.put(`${API_URL}/promotions/${id}`, data);
    },

    // حذف جشنواره
    deletePromotion(id) {
        return axios.delete(`${API_URL}/promotions/${id}`);
    },

    // دریافت گزارش جشنواره
    getPromotionReport(id, params = {}) {
        return axios.get(`${API_URL}/promotions/${id}/report`, { params });
    },

    // ============ کوپن‌های کاربران ============

    // لیست کوپن‌های کاربران
    getUserPromotions(params = {}) {
        return axios.get(`${API_URL}/user-promotions`, { params });
    },

    // لغو کوپن
    revokeUserPromotion(id) {
        return axios.post(`${API_URL}/user-promotions/${id}/revoke`);
    },

    // استفاده از کوپن
    useUserPromotion(id, data) {
        return axios.post(`${API_URL}/user-promotions/${id}/use`, data);
    },

    // ============ سرویس‌ها (برای انتخاب در فرم) ============

    // لیست خدمات سالن
    getServices() {
        return axios.post('/api/admin/site/get_lines\n');
    }
};